export default {
  products: 'Produits',
  search: 'Recherche',
  accountArea: 'Espace client',
  whyUs: 'Pourquoi nous',
  services: 'Services',
  company: 'Maison',
  news: 'Actualités',
  resources: 'Ressources',
  contacts: 'Contacts',
  shop: 'Boutique',
  privacy: 'Politique de confidentialité',
  cookie: 'Politique de cookies',
  copyright: 'Copyright',
  conditions: 'Conditions d’utilisation',
  language: 'Changer de langue',
  comeFarePer: 'Comment faire pour',
}
